import { cookieManager } from "./cookie";
import { getQueryParam } from "./queryParameters";

/**
 * Default bucket value for when exp_bucket cookie is not set and no query param is found.
 */
const DefaultBucket = "100";

/**
 * Regex to check if the cookie is in the new format of `v<version>-<bucket number>`. The old format
 * was just `<bucket number>`. This change was implemented April 2025.
 */
const newCookieFormatRegex = /^(?:v\d+-)?(\d{2})$/;

/**
 * Returns the current exp_bucket value from one of the following locations (in order of priority):
 * 1. Forced bucket value via query param `?pf_pathfinder_force_bucket=<bucket>`
 * 2. Value set on `exp_bucket` cookie
 * 3. The default bucket of `100`
 *
 * If the query param or exp_bucket value is in the new format prefixed with version, then the
 * bucket number will be extracted first. For example if the provided bucket value is `v5-99`, then
 * this function will return `99`.
 *
 * @returns The bucket number for this user.
 */
export function getExpBucket(): string {
  // Get the bucket value either from query param or cookie.
  let bucketValue =
    getQueryParam("pf_pathfinder_force_bucket") ??
    cookieManager.get("exp_bucket");

  // If this is in the new format, then grab the bucket number only
  const matches = bucketValue?.match(newCookieFormatRegex);
  if (matches && matches.length >= 2) {
    bucketValue = matches[1];
  }

  return bucketValue ?? DefaultBucket;
}
